import React from "react";
import "./sidebar.css";
import { useHistory, useLocation } from "react-router-dom";
import newLogoo from "../../../../../assets/images/newLogo.png";
import dashboard from "../../../../../assets/images/Vector.png";
import dropoff from "../../../../../assets/images/location.png";
import pickup from "../../../../../assets/images/pickup.png";
import history from "../../../../../assets/images/history.png";
import drivers from "../../../../../assets/images/drivers.png";
import collection from "../../../../../assets/images/collection.png";
import wallet from "../../../../../assets/images/wallet.png";
import support from "../../../../../assets/images/support.png";
import settings from "../../../../../assets/images/settings.png";
import { FaTimes } from "react-icons/fa";

const Sidebar = ({ sidebarOpen, closeSidebar }) => {
  const location = useLocation();
  const historys = useHistory();
  return (
    <div className={sidebarOpen ? "sidebar_responsive" : ""} id="sidebar">
      <div className="sidebar__title">
        <div
          className="sidebar__img"
          onClick={() => {
            historys.push("/dashboards");
            localStorage.setItem("title", "Dashboard");
          }}
          style={{ cursor: "pointer" }}
        >
          <img src={newLogoo} alt="logo" />
        </div>
        <div
          style={{
            backgroundColor: "#c4da00",
            width: "30px",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
          }}
          className="nav_icon nav_icons"
        >
          <FaTimes
            id="sidebarIcon"
            onClick={() => closeSidebar()}
            style={{ color: "#fff" }}
          />
        </div>
      </div>

      <div className="sidebar__menu">
        <div
          className={`${
            location.pathname === "/dashboards"
              ? "active-menu_link"
              : "sidebar__link"
          }`}
        >
          <div className="icon__img">
            <img src={dashboard} />
          </div>

          <a href="/dashboards">Dashboards</a>
        </div>

        <div
          className={`${
            location.pathname === "/dashboards/dropOff"
              ? "active-menu_link"
              : "sidebar__link"
          }`}
        >
          <div className="icon__img">
            <img src={dropoff} alt="drop" />
          </div>
          <a href="/dashboards/dropOff">Drop Off Requests</a>
        </div>

        <div
          className={`${
            location.pathname === "/dashboards/pickUpRequest"
              ? "active-menu_link"
              : "sidebar__link"
          }`}
        >
          <div className="icon__img">
            <img src={pickup} alt="pick" />
          </div>
          <a href="/dashboards/pickUpRequest">Pick Up Requests</a>
        </div>

        <div
          className={`${
            location.pathname === "/dashboards/history"
              ? "active-menu_link"
              : "sidebar__link"
          }`}
        >
          <div className="icon__img">
            <img src={history} alt="history" />
          </div>
          <a href="/dashboards/history">History</a>
        </div>

        <div
          className={`${
            location.pathname === "/dashboards/drivers"
              ? "active-menu_link"
              : "sidebar__link"
          }`}
        >
          <div className="icon__img">
            <img src={drivers} alt="driver" />
          </div>
          <a href="/dashboards/drivers">Drivers</a>
        </div>

        <div
          className={`${
            location.pathname === "/dashboards/aggregationCenter" ||
            location.pathname === "/dashboards/aggregationScheduled"
              ? "active-menu_link"
              : "sidebar__link"
          }`}
        >
          <div className="icon__img">
            <img src={collection} alt="collection" />
          </div>
          <a href="/dashboards/aggregationCenter">Aggregation Center</a>
        </div>

        <div
          className={`${
            location.pathname === "/dashboards/wallet"
              ? "active-menu_link"
              : "sidebar__link"
          }`}
        >
          <div className="icon__img">
            <img src={wallet} alt="wallet" />
          </div>
          <a href="/dashboards/wallet">Wallet</a>
        </div>

        <div
          className={`${
            location.pathname === "/dashboards/support"
              ? "active-menu_link"
              : "sidebar__link"
          }`}
        >
          <div className="icon__img">
            <img src={support} alt="support" />
          </div>
          <a href="/dashboards/support">Support</a>
        </div>

        <div
          className={`${
            location.pathname === "/dashboards/settings"
              ? "active-menu_link"
              : "sidebar__link"
          }`}
        >
          <div className="icon__img">
            <img src={settings} alt="settings" />
          </div>
          <a href="/dashboards/settings">Settings</a>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
